import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";
import React from "react";

type Props = {
  isOpen: boolean;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onClose: () => void;
}

/**
 * A dialog that asks the user to confirm an action
 *
 * @param isOpen Initial state of the dialog
 * @param title Title of the dialog
 * @param message Message of the dialog
 * @param confirmText Text of the confirm button
 * @param cancelText Text of the cancel button
 * @param onConfirm Callback for when the user confirms the action
 * @param onClose Callback for when the user cancels the action or the dialog is closed
 * @constructor
 */
export default function ActionDialog({
                                       isOpen,
                                       title,
                                       message,
                                       confirmText,
                                       cancelText,
                                       onConfirm,
                                       onClose
                                     }: Props) {
  return (
      <Dialog open={isOpen} onClose={onClose}>
        <DialogTitle>{title ?? "Sind Sie sich sicher?"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {message ?? "Wenn Sie fortfahren, können Sie diese Aktion nicht rückgängig machen."}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={_ => onClose()}>{cancelText ?? "Abbrechen"}</Button>
          <Button variant="contained" onClick={_ => onConfirm()}>{confirmText ?? "Okay"}</Button>
        </DialogActions>
      </Dialog>
  );
}